import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import ThankYou from '../ThankYou';

import logo from '../../assets/images/global/seakeeper-logo-only.svg';

class SizingFormCreated extends Component {

	render() {

		var title = <span>Thank you for submitting a <br />Seakeeper Sizing Form!</span>,
			message = <span>We'll notify you when your report is published. <br />You can check its status on your <a href="/dashboard">Dashboard</a>.</span>;

		return (
			<Page pageClass="pp-sizing-form-thank-you-page">
				<ThankYou
					icon={logo}
				 	title={title}
					message={message}
				/>
			</Page>
		);
	}
}

export default SizingFormCreated;



// WEBPACK FOOTER //
// ./src/components/pages/SizingFormCreated.js